// --- ENUMS (Mapped directly from Prisma schema) ---

export enum StaffRole {
    SUPER_ADMIN = "SUPER_ADMIN",
    REGION_MANAGER = "REGION_MANAGER",
    CITY_MANAGER = "CITY_MANAGER",
    FIELD_AGENT = "FIELD_AGENT",
    VERIFICATION_OPS = "VERIFICATION_OPS",
    SUPPORT_AGENT = "SUPPORT_AGENT",
    MARKETING = "MARKETING"
}

export enum StaffStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    SUSPENDED = "SUSPENDED",
    TERMINATED = "TERMINATED",
    PENDING_APPROVAL = "PENDING_APPROVAL"
}

export type StaffPhotoStatus = 'NONE' | 'PENDING' | 'APPROVED' | 'REJECTED';

// --- INTERFACES ---

export interface StaffUser {
    id: number;
    username?: string;
    // password?: string; // Deliberately omitted for frontend security
    phoneNumber?: string;
    firebaseUid?: string;
    email?: string;
    firstName: string;
    lastName?: string;
    role: StaffRole;
    status: StaffStatus;
    assignedRegions?: string[]; // e.g., ["BLR", "LKO"]
    permissions?: Record<string, any>; // Mapped from Prisma Json?
    /** Reporting line: InternalUser.id of this member's manager; null/undefined = top level. */
    managerId?: number | null;
    /** Approved photo (public URL) — the only one other people see. */
    photoUrl?: string | null;
    /** Photo the person uploaded that is waiting for review. */
    pendingPhotoUrl?: string | null;
    photoStatus?: StaffPhotoStatus;
    photoRejectReason?: string | null;
    lastLoginAt?: string; // Dates arrive as ISO strings from API
    lastLoginIp?: string;
    failedLoginCount: number;
    createdAt: string;
    updatedAt: string;
}

// --- TEAM PERFORMANCE (enrollment + agent-booking numbers per person) ---

export type PeriodKey = 'today' | 'yesterday' | 'month' | 'allTime';

export interface EnrollmentBucket { enrolled: number; approved: number; pending: number }
export interface RideBucket { requested: number; completed: number; cancelled: number }

export interface TeamScopeStats {
    periods: Record<PeriodKey, EnrollmentBucket>;
    rides: Record<PeriodKey, RideBucket>;
}

/** `own` is that person alone; `team` is their whole branch, null when too large to roll up live. */
export interface TeamLevelPerson {
    staffId: number;
    name: string;
    title: string;
    role: string;
    status: string;
    directReports: number;
    teamSize: number;
    own: TeamScopeStats;
    team: TeamScopeStats | null;
}

/** One LEVEL of the tree. Children arrive from a further call for that person. */
export interface TeamLevelStats {
    manager: TeamLevelPerson;
    members: TeamLevelPerson[];
}
